import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '../api'

interface LeadItem {
  id: number
  name: string
  first_name: string
  last_name: string
  email: string
  phone: string
  company: string
  country: string
  website: string
  industry: string
  product_interests: string
  source_title: string
  type: string
  created_at: string
}

export default function LeadsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [list, setList] = useState<LeadItem[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const typeFilter = searchParams.get('type') || ''
  const page = parseInt(searchParams.get('page') || '1')
  const pageSize = 20

  const fetchList = async () => {
    setLoading(true)
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    if (typeFilter) params.set('type', typeFilter)

    const res = await api.get(`/api/admin/leads?${params}`)
    if (res.success) {
      setList(res.data.list)
      setTotal(res.data.pagination.total)
    }
    setLoading(false)
  }

  useEffect(() => { fetchList() }, [page, typeFilter])

  const totalPages = Math.ceil(total / pageSize)

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">表单采集</h1>
      </div>

      <div className="search-bar">
        <select
          className="form-input"
          value={typeFilter}
          onChange={(e) => setSearchParams({ type: e.target.value, page: '1' })}
          style={{ width: 'auto' }}
        >
          <option value="">全部类型</option>
          <option value="case">案例线索</option>
          <option value="report">报告线索</option>
        </select>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>类型</th>
            <th>来源</th>
            <th>姓</th>
            <th>名</th>
            <th>邮箱</th>
            <th>电话</th>
            <th>公司</th>
            <th>国家/地区</th>
            <th>公司网址</th>
            <th>时间</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={11} style={{ textAlign: 'center' }}>加载中...</td></tr>
          ) : list.length === 0 ? (
            <tr><td colSpan={11} style={{ textAlign: 'center' }}>暂无数据</td></tr>
          ) : (
            list.map((item) => (
              <tr key={`${item.type}-${item.id}`}>
                <td>{item.id}</td>
                <td>
                  <span className={`badge ${item.type === 'case' ? 'badge-success' : 'badge-secondary'}`}>
                    {item.type === 'case' ? '案例' : '报告'}
                  </span>
                </td>
                <td>{item.source_title || '-'}</td>
                <td>{item.last_name || '-'}</td>
                <td>{item.first_name || '-'}</td>
                <td>{item.email}</td>
                <td>{item.phone || '-'}</td>
                <td>{item.company}</td>
                <td>{item.country || '-'}</td>
                <td>{item.website || '-'}</td>
                <td>{item.created_at ? new Date(item.created_at).toLocaleDateString('zh-CN') : '-'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="pagination">
          <button disabled={page <= 1} onClick={() => setSearchParams({ page: String(page - 1), type: typeFilter })}>
            上一页
          </button>
          <span>第 {page} / {totalPages} 页</span>
          <button disabled={page >= totalPages} onClick={() => setSearchParams({ page: String(page + 1), type: typeFilter })}>
            下一页
          </button>
        </div>
      )}
    </div>
  )
}
